import _ = require("underscore");
import Portal = require("portal-gis");
import Backbone = require("backbone");
import $ = require("jquery");
import ol = require("ol");
import Utils = require("../utils");
import globals = require("../../globals");
import rest = require("ips-rest");
const log = Utils.log;

export interface API {
    stub?: boolean;
    endpoint?: string;
    query?: any;
    auth?: () => { Username: string }
}

let authDeferred: JQueryDeferred<any>;

export class BaseService<T> {

    public idAttribute: string;

    constructor(public api: API, public serviceName: string) {
        this.idAttribute = "id";

        this.api = _.defaults(api || {}, <API>{
            endpoint: globals.services,
            query: {
                merge: true
            },
            auth: () => {
                return { Username: "Hansen8" };
            }
        });
    }

    auth<D>(cb: () => JQueryXHR) {

        // debounced so multiple calls to not result in multiple authentications
        var d = $.Deferred<D>();

        var doit = () => {
            var req = cb();
            req.done(json => {
                authDeferred = null;
                d.resolve(json);
            });
            return req;
        };

        if (authDeferred) {
            log(`${this.serviceName}: queuing request`);
            authDeferred.done(() => doit());
            return d;
        }

        authDeferred = d;

        doit().fail((err, status) => {
            // 404 should not be reported when authentication fails!
            if (err.status === 401 || err.status === 0 || err.status === 404) {
                var req = $.ajax({
                    type: "GET",
                    url: `${this.api.endpoint}/auth`,
                    data: this.api.auth(),
                    dataType: "json",
                    contentType: "application/json",
                    proxy: false,
                    cache: globals.cachebust !== "1"
                });

                req.done((result, status) => {
                    if (status === "success") {
                        doit().fail(status => {
                            console.error("post-auth service failure:", status);
                            authDeferred = null;
                            d.reject(result, status);
                        });
                        return;
                    }
                    console.error("auth failure result:", result);
                    authDeferred = null;
                    d.reject(err, status);
                });

                req.fail((err, status) => {
                    console.error("auth failure status:", status);
                    authDeferred = null;
                    d.reject(err, status);
                });
            }
            else {
                console.error("service failure:", status);
                authDeferred = null;
                d.reject(err, status);
            }
        });

        return d;
    }

    public get(id: number | string): JQueryDeferred<T> {

        let q = this.api.query ? "?" + $.param(this.api.query) : "";

        return this.auth<T>(() => $.ajax({
            dataType: "json",
            url: `${this.api.endpoint}/${this.serviceName}/${id}${q}`,
            proxy: false,
            cache: globals.cachebust !== "1"
        }));

    }

    public post(data) {
        return this.auth<T>(() => $.ajax(`${this.api.endpoint}/${this.serviceName}`, {
            type: "POST",
            dataType: "json",
            contentType: "application/json",
            data: data,
            proxy: false,
            cache: globals.cachebust !== "1"
        }));
    }

    public put(id: number | string, data) {
        return this.auth<{ href: string }>(() => $.ajax(`${this.api.endpoint}/${this.serviceName}/${id}`, {
            type: "PUT",
            dataType: "json",
            data: data,
            proxy: false,
            cache: globals.cachebust !== "1"
        }));

    }

    public delete(id: number | string) {
        return this.auth<{ href: string }>(() => $.ajax(`${this.api.endpoint}/${this.serviceName}/${id}`, {
            type: "DELETE",
            dataType: "json",
            proxy: false,
            cache: globals.cachebust !== "1"
        }));
    }

    // TODO: shouldn't this be fetch?
    public each() {

        var d = $.Deferred<Array<T>>();

        let q = this.api.query;
        if (typeof q === "string") q = JSON.parse(q);
        if (q) q = "?" + $.param(q);

        let req = this.auth<{ data: T[] }>(() => $.ajax(`${this.api.endpoint}/${this.serviceName}${q}`, {
            dataType: "json",
            proxy: false,
            cache: globals.cachebust !== "1"
        }));

        req.done(ids => d.resolve(ids.data));
        req.fail(err => {
            console.error("each() failed:", err);
            d.reject(err);
        });

        return d;
    }
}

export class BusinessService<T> extends BaseService<T> {
}

class BaseMetaService<T extends rest.MetaService> extends BaseService<T> {
    public fetch() {

        var d = $.Deferred<T>();

        let q = this.api.query;
        if (typeof q === "string") q = JSON.parse(q);
        if (q) q = "?" + $.param(q);

        let req = this.auth<T>(() => $.ajax(`${this.api.endpoint}/${this.serviceName}${q}`, {
            dataType: "json",
            proxy: false,
            cache: true
        }));

        req.done(response => d.resolve(response));
        req.fail(err => {
            console.error("fetch() failed:", err);
            d.reject(err);
        });

        return d;
    }

}

export class MetaService extends BaseMetaService<rest.MetaService> { }
